import axios from 'axios';

const state = {};
const getters = {};

const actions = {
    mayar_list({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('mayar-integrations')
                .then(res => { commit("PUSH_MAYAR", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    mayar_one({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.get('mayar-integration/' + id)
                .then(res => { commit("PUSH_MAYAR", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    mayar_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('mayar-integration', data)
                .then(res => { commit("PUSH_MAYAR", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    mayar_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            const { id, ...payload } = data;
            axios.put('mayar-integration/' + id, payload)
                .then(res => { commit("PUSH_MAYAR", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    mayar_delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.delete('mayar-integration/' + id)
                .then(res => { commit("PUSH_MAYAR", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    mayar_test({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.post('mayar-integration/' + id + '/test')
                .then(res => { commit("PUSH_MAYAR", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
};

const mutations = {
    PUSH_MAYAR() { /* no-op */ }
};

export default { state, getters, actions, mutations };
